import { Grid2 } from '@mui/material';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import ExpenseDatePicker from './ExpenseDatePicker';
import { COLORS } from '../../../utils/Application_Constants';
import moment from 'moment/moment';
import eventBus from './EventBus';
import { useEffect } from 'react';

const toMoment = (v) => {
    if (!v) return null;
    if (moment.isMoment(v)) return v;
    if (v instanceof Date || typeof v === 'number') return moment(v);
    if (typeof v === 'string') {
        const m = moment(v, ['YYYY-MM-DD', 'MM/DD/YYYY', moment.ISO_8601], true);
        return m.isValid() ? m : moment(v);
    }
    return null;
};

const ExpensePostedDate = (props) => {
    const { index, expense, isViewOnly } = props;
    const { control, errors, setValue } = useFormContext();

    const today = moment().startOf('day');
    const minAllowed = moment().subtract(60, 'days').startOf('day');

    const statusPath = `expenseEntries[${index}].status`;
    const postingDatePath = `expenseEntries[${index}].postingDate`;
    const postingDateUiEmptyPath = `expenseEntries[${index}].postingDateUiEmpty`;

    const status = useWatch({ control, name: statusPath });
    const postingDate = useWatch({ control, name: postingDatePath });

    useEffect(() => {
        if (status === 'Approved' && !postingDate) {
            const today = new Date();

            setValue(postingDatePath, today, { shouldValidate: true, shouldDirty: true });
            setValue(postingDateUiEmptyPath, false, { shouldDirty: true });

            eventBus.emit(`postingDateChanged${index}`, {
                data: moment(today).format('YYYY-MM-DD'),
            });
        }
    }, [status, postingDate, index, postingDatePath, postingDateUiEmptyPath, setValue]);

    return (
        <Grid2 item size={{ xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={postingDateUiEmptyPath}
                defaultValue={false}
                render={() => null}
            />
            <Controller
                control={control}
                name={postingDatePath}
                defaultValue={expense.postingDate || null}
                disabled={isViewOnly}
                render={({ onChange, value }) => {
                    const mValue = toMoment(value);
                    return (
                        <ExpenseDatePicker
                            value={mValue}
                            onChange={(e) => {
                                if (!e) {
                                    onChange(null);
                                    setValue(postingDateUiEmptyPath, true, { shouldDirty: true });
                                    eventBus.emit(`postingDateChanged${index}`, { data: null });
                                    return;
                                }
                                const picked = toMoment(e)?.startOf('day');
                                onChange(picked);
                                setValue(postingDateUiEmptyPath, false, { shouldDirty: true });
                                if (picked?.isValid?.()) {
                                    eventBus.emit(`postingDateChanged${index}`, {
                                        data: picked.format('YYYY-MM-DD'),
                                    });
                                }
                            }}
                            disabled={isViewOnly}
                            id={`post-date-${index}`}
                            label="Post Date"
                            required={false}
                            minDate={minAllowed}
                            maxDate={today}
                            parentTextFieldProps={{
                                error: Boolean(errors.expenseEntries?.[index]?.postingDate),
                                helperText: errors.expenseEntries?.[index]?.postingDate?.message,
                            }}
                            parentSx={{
                                '& .MuiInputBase-root': {
                                    borderColor: !errors.expenseEntries?.[index]?.postingDate
                                        ? 'default'
                                        : `${COLORS.LT_PEPPER} !important`,
                                },
                            }}
                        />
                    );
                }}
            />
        </Grid2>
    );
};

export default ExpensePostedDate;
